<template>
  <div
    tabindex="0"
    class="dropdown"
    :class="{
      box: box,
      'hide-label': !showExpandedLabel,
      disabled: disabled,
      searchable: isSearchable,
    }"
    @keydown="onRootKeyDown"
  >
    <v-layout row wrap>
      <v-flex md12>
        <v-menu
          ref="dropdownMenu"
          v-model="showDrodpownList"
          transition="slide-y-transition"
          full-width
          :closeOnContentClick="false"
          offset-y
          :disabled="disabled"
        >
          <div
            slot="activator"
            class="dropdown--main"
            :class="{
              borderbottom: borderbottom,
              expanded: !selected,
            }"
          >
            <div
              class="dropdown--main__label"
              :class="{
                expanded: multiple ? isMultipleNotSelected : !selected,
              }"
              :style="{
                opacity: box && isSearchable ? (selected ? 1 : 0) : 1,
                zIndex: box && isSearchable ? (selected ? 0 : -1) : 0,
              }"
              v-if="box ? (showExpandedLabel ? true : !selected) : false"
            >
              <!-- + "--" + psBuffer -->
              {{ placeholder }}
            </div>
            <div v-if="showMainText" class="dropdown--main__text">
              <template v-if="isSelectedObject">
                <template>
                  <div
                    v-if="status"
                    class="dropdown--main__status"
                    :style="{
                      backgroundColor: selected.color || 'black',
                    }"
                  ></div>
                  <template v-if="i18nKey">
                    {{ $dft.capHead($t(selected.text)) }}
                  </template>
                  <template v-else>
                    {{ selected.text }}
                  </template>
                </template>
              </template>
              <template v-if="isSelectedString">{{ selected }}</template>
              <template v-if="isNotMultipleNorSelected">{{
                placeholder
              }}</template>
              <!-- For Border Bottom - Multiple Selection does not have the  Label-->
              <span
                v-if="borderbottom && isMultipleNotSelected"
                style="color: var(--text-5)"
              >
                {{ placeholder }}
              </span>
              <span
                class=""
                v-if="multiple && !isMultipleNotSelected"
                :class="{ placeholder: isMultiplePlaceholder }"
                :title="multipleLabel"
                >{{ multipleLabel }}
              </span>
            </div>
            <div class="dropdown--main__search-input" v-if="isSearchable">
              <input
                id="searchableInput"
                type="text"
                :value="searchStringValue"
                @input="onSearchStringChange"
                @focus="onSearchFocus"
                @blur="onSearchBlur"
                :placeholder="placeholder"
              />
            </div>
            <div
              v-if="!box && !selected && !isSearchable"
              class="dropdown--main__text placeholder"
              :title="placeholder"
            >
              {{ placeholder }}
            </div>
            <!-- <div v-if="multiple" class="dropdown--main__text" >
              
            </div>-->
            <div
              @click="onFocus"
              class="dropdown--main__icon"
              v-if="!showDrodpownList"
            >
              <div v-if="showExpandStatusIcon" class="dt-icon-container">
                <img
                  src="static/icons/arrows/chevron-down.svg"
                  :class="`dt-icon v6 s1 h${config.iconHoverStyle}`"
                  alt
                />
              </div>
            </div>
            <div
              @click="onFocus"
              class="dropdown--main__icon"
              v-if="showDrodpownList"
            >
              <div v-if="showExpandStatusIcon" class="dt-icon-container">
                <img
                  src="static/icons/arrows/chevron-up.svg"
                  :class="`dt-icon v6 s1 h${config.iconHoverStyle}`"
                  alt
                />
              </div>
            </div>
          </div>

          <div
            class="dropdown--list"
            ref="dropdown--list"
            :style="{
              'max-height': listHeight + 'px',
              'min-width': listMinWidth + 'px',
            }"
            tabindex="0"
            @keydown="onDropdownKeyup"
          >
            <div class="dropdown--item" v-if="deselect" @click="onDeselect">
              <div class="dropdown--item--text" style="height: 19px">
                {{ deselectLabel }}
              </div>
            </div>
            <div class="dropdown--item" v-if="allnone" @click.stop="onAllnone">
              <div class="dropdown-item--checkbox">
                <div class="dt-checkbox">
                  <input
                    type="checkbox"
                    :checked="selectedItemsC.length == optionsList.length"
                    @click.stop="onAllnone"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
              <div class="dropdown--item--text" style="height: 19px">
                {{ allnoneLabel }}
              </div>
            </div>
            <template v-if="optionsList.length > 0">
              <div
                class="dropdown--item"
                v-for="(item, index) in optionsList"
                :key="item.value + '-' + index"
                :ref="'optionItem' + item.value"
                @click.stop="item.value == '-' ? undefined : clickItem(item)"
                :class="{
                  selected: !multiple && item.selected,
                  separator: item.value == '-',
                }"
                :tabindex="index + 1"
              >
                <template v-if="multiple">
                  <div class="dropdown-item--checkbox">
                    <div class="dt-checkbox">
                      <input
                        type="checkbox"
                        :checked="selectedIds.has(item.value + '')"
                        @click.stop="clickItem(item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
                  <div class="dropdown--item--text">
                    <template v-if="i18nKey">
                      {{ $dft.capHead($t(item.text)) }}
                    </template>
                    <template v-else>
                      {{ item.text }}
                    </template>
                  </div>
                </template>
                <template v-else>
                  <slot name="item" v-bind:item="item" v-bind:index="index">
                    <div
                      class="dropdown--item--text"
                      :class="{
                        status: status,
                      }"
                    >
                      <div
                        v-if="status"
                        class="dropdown--item--status"
                        :style="{
                          backgroundColor: item.color || 'black',
                        }"
                      ></div>
                      <template v-if="i18nKey">
                        {{ $dft.capHead($t(item.text)) }}
                      </template>
                      <template v-else>
                        {{ item.text }}
                      </template>
                    </div>
                  </slot>
                </template>
              </div>
            </template>
            <div
              :style="{
                maxHeight: loadingFlag ? '30px' : '0px',
                opacity: loadingFlag ? '1' : '0',
              }"
            >
              <div
                class="ut-rowcen"
                :style="{
                  padding: loadingFlag ? '5px' : '0px',
                  maxHeight: loadingFlag ? '30px' : '0px',
                }"
              >
                <img src="static/icons/loading.gif" alt />
              </div>
            </div>
            <div
              class="no-item"
              v-if="!loadingFlag && optionsList.length === 0"
            >
              <template v-if="isSearchable && searchStringValue.length === 0">
                Please enter 1 or more characters
              </template>
              <template v-else> No Items </template>
            </div>
          </div>
        </v-menu>

        <div
          class="validation-status"
          :class="{
            'status-inside': statusInside,
          }"
        >
          <div
            class="dt-icon-container"
            v-if="showValidationIcons"
            @click="(e) => removeContactRelation(contact)"
          >
            <img
              v-if="(touched || immediateValidation) && validationResult.valid"
              src="static/icons/textbox-complete.svg"
              class="dt-icon"
              alt
            />
            <img
              v-if="(touched || immediateValidation) && !validationResult.valid"
              :title="errorMessages()"
              src="static/icons/textbox-incomplete.svg"
              class="dt-icon"
              alt
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Subject } from "rxjs";
import { createDropdownConfig } from ".";
import { NotificationService } from "../../dt-plugins/notification/notification.service";
import {
  addRemoveSet,
  getAlphabet,
  getTimeNumber,
  subscribeSubject,
} from "../../utility";
import { cycleArrayNext } from "../../utility/fp";

const passiveSearchDelay = 300;

export const dropdownProps = {
  options: {
    type: Array,
    required: true,
    default: () => [
      {
        text: "Select",
        value: "select",
      },
    ],
  },
  required: {
    type: Boolean,
    default: false,
  },
  tabindex: {
    type: Number,
    default: 0,
  },
  showValidationIcons: {
    type: Boolean,
    default: false,
  },
  immediateValidation: {
    type: Boolean,
    default: false,
  },
  statusInside: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
  },
  selected: {
    type: [Object, Array],
  },
  multiple: {
    type: Boolean,
  },
  maxSelection: {
    type: Number,
    default: Infinity,
  },
  box: {
    type: Boolean,
  },
  listHeight: {
    type: Number,
    default: 200,
  },

  listMinWidth: {
    type: Number,
    default: 200,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  deselect: {
    type: Boolean,
    default: false,
  },
  deselectLabel: {
    type: String,
    default: "",
  },
  allnone: {
    type: Boolean,
    default: false,
  },
  borderbottom: {
    type: Boolean,
    default: false,
  },
  config: {
    type: Object,
    default: () => createDropdownConfig(),
  },
  showExpandedLabel: {
    type: Boolean,
    default: true,
  },
  isSearchable: {
    type: Boolean,
    default: false,
  },
  showExpandStatusIcon: {
    type: Boolean,
    default: true,
  },
  loadingFlag: {
    type: Boolean,
    default: false,
  },
  status: {
    type: Boolean,
    default: false,
  },
  i18nKey: {
    type: Boolean,
    default: false,
  },
};

export default {
  props: dropdownProps,
  watch: {
    options: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (newValue.length > 0 && typeof newValue[0] === "string") {
          this.inputType = "string_array";

          this.optionsList = newValue.map((e) => ({
            text: e,
            value: e,
            selected: false,
          }));
        } else if (
          newValue.length > 0 &&
          newValue[0].value &&
          newValue[0].text
        ) {
          this.inputType = "object_array";

          this.optionsList = newValue.map((e) => ({
            text: e.text,
            value: e.value,
            color: e.color,
            selected: e.selected,
          }));
        } else {
          this.optionsList = [];
        }

        // console.log(this.options, this.optionsList);
        // console.log(this.$refs['dropdownMenu']);
      },
    },
    selected: {
      immediate: true,
      handler: function (newValue, oldValue) {
        // console.error(newValue);
        if (this.options.length == 35) {
          console.error({ newValue: newValue });
        }
        if (newValue && newValue.length > 0 && typeof newValue === "object") {
          if (newValue.length > 0 && typeof newValue[0] === "string") {
            // this.selectedItems = newValue.map(e => ({
            //   text: e,
            //   value: e,
            //   selected: true
            // }));

            // Computed SelectedItemsC -- Type String Array
            // this.optionsList = this.optionsList.map((e) => {
            //   if (newValue.includes(e.value)) {
            //     e.selected = true;
            //   } else {
            //     e.selected = false;
            //   }
            //   return e;
            // });

            this.selectedIds = new Set([newValue]);

            // console.log('string', newValue, this.optionsList);
          } else if (
            newValue.length > 0 &&
            newValue[0].value &&
            newValue[0].text
          ) {
            // this.selectedItems = newValue.map(e => ({
            //   text: e.text,
            //   value: e.value,
            //   selected: true
            // }));

            // Computed SelectedItemsC -- Type TV Array

            // const valueList = newValue.map((e) => e.value);

            // this.optionsList = this.optionsList.map((e) => {
            //   if (valueList.includes(e.value)) {
            //     e.selected = true;
            //   } else {
            //     e.selected = false;
            //   }
            //   return e;
            // });

            // console.log('object', newValue, this.optionsList);

            this.selectedIds = new Set(newValue.map((e) => `${e.value}`));
          }
        } else if (newValue && newValue.text && newValue.value) {
          // console.log(this.optionsList);
          // this.optionsList = this.optionsList.map((e) => {
          //   if (e.value === newValue.value) {
          //     e.selected = true;
          //   } else {
          //     e.selected = false;
          //   }
          //   return e;
          // });

          this.selectedIds = new Set([`${newValue.value}`]);

          // TODO: If there is no selected option that matches selected - Then assign placeholder as the selectd value

          if (this.selectedItemsC.length == 0) {
          }

          // const selectedOption = this.optionsList.find(
          //   (e) => e.value == newValue.value
          // );
          // if (!selectedOption) {
          //   newValue.text = this.placeholder;
          // }

          // console.log('single', newValue, this.optionsList);
        } else if (newValue && typeof newValue === "string") {
          // this.optionsList = this.optionsList.map((e) => {
          //   if (e.value === newValue) {
          //     e.selected = true;
          //   } else {
          //     e.selected = false;
          //   }
          //   return e;
          // });

          this.selectedIds = new Set([`${newValue}`]);
          // console.error('single string', newValue, this.optionsList);
        } else if (newValue && newValue.text === "" && newValue.value === "") {
          // this.optionsList = this.optionsList.map((e) => ({
          //   ...e,
          //   selected: false,
          // }));
          this.resetSelectedIds();
        } else if (!newValue) {
          // this.optionsList = this.optionsList.map((e) => ({
          //   ...e,
          //   selected: false,
          // }));
          this.resetSelectedIds();
        } else if (R.isEmpty(newValue)) {
          this.resetSelectedIds();
        }

        // console.log(this.optionsList);

        // For ImmediateValidation validate the inout right after the Selected prop value is passed
        // It will only work while untouched. If The control is touched - It will be a infinite feedback loop in some cases
        if (this.immediateValidation) {
          // console.log("Log: this.immediateValidation", this.immediateValidation)
          this.validate();
        }
      },
    },
    showDrodpownList: {
      immediate: true,
      handler: function (to, from) {
        // Handle Search String
        if (this.isSearchable) {
          // this.searchString = "";
        } else {
          if (to) {
            this.scrollIntoView();

            // For Multiple Dropdowns - Focus is disabled, Why was it done ? I forgot now
            // Lets Remove this Logic and Test 
            // Probably the FocusIndex Calculation would be Bugged for Arrow,

            if (true) {
              if (this.selectedItemsC.length === 1) {
                const focusedIndex = this.optionsList.findIndex(
                  (e) => e.value == this.selectedItemsC[0].value
                );

                setTimeout(() => {
                  this.focusIndex(focusedIndex);
                }, 100);
              } else if (this.selectedItemsC.length === 0) {
                setTimeout(() => {
                  this.focusIndex(this.focusedIndex);
                }, 100);
              }
            }
          } else {
            // setTimeout(() => {
            // this.$el.focus();
            // }, 300);
          }
        }
      },
    },
  },
  mounted: function () {
    subscribeSubject(this, this.searchSubject, (string) => {
      console.log(string);
      console.log({ "this.searchString": this.searchString });
      this.$emit("searched", this.searchString);
    });
  },
  data: function () {
    return {
      showDrodpownList: false,
      optionsList: [],
      inputType: "string_array",

      validationResult: {
        valid: true,
        errorMessages: [],
      },
      touched: false,

      focusedIndex: 0,

      // New ID Set Based Solution
      selectedIds: new Set(),

      // Active Search Data
      searchString: "",
      searchSubject: new Subject(),
      searchTypeFlag: false,

      // Passive Search Data
      psBuffer: "",
      psTime: getTimeNumber(),
      psTimeout: null,
    };
  },
  computed: {
    selectedIdsArray() {
      return Array.from(this.selectedIds);
    },
    // selectedItemsC1: function () {
    //   return this.optionsList.filter((e) => e.selected);
    // },
    selectedItemsC: function () {
      // console.log(this.optionsList);
      // const has = this.selectedIds.has(`12`);
      // const has2 = this.selectedIds.has(12);

      return this.optionsList.filter((e) => {
        // if (e.value == "12") {
        //   debugger;
        // }
        // console.log({
        //   "this.selectedIds": new Set(this.selectedIds),
        //   "this.selectedIds Arr": Array.from(this.selectedIds),
        //   len: this.selectedIds.size,
        //   "e.value": e.value,
        //   has: this.selectedIds.has(`${e.value}`),
        // });
        return this.selectedIds.has(`${e.value}`);
      });
      // return this.optionsList.filter((e) => e.selected);
    },
    allnoneLabel: function () {
      return `Select All/ None`;
      // if (this.selectedItemsC.length == this.optionsList.length) {
      //   return "Select None";
      // } else {
      //   return "Select All";
      // }
    },
    multipleLabel: function () {
      if (this.multiple) {
        if (this.selectedItemsC.length > 0) {
          return this.selectedItemsC.map((e) => e.text).join(", ");
        } else {
          return this.placeholder;
        }
      } else {
        return "";
      }
    },
    isMultiplePlaceholder: function () {
      if (this.multiple) {
        if (this.selectedItemsC.length > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },

    searchStringValue() {
      return this.searchTypeFlag
        ? this.searchString
        : this.selected?.text
        ? this.selected?.text
        : "";
    },

    isSelectedObject() {
      return (
        this.selected &&
        typeof this.selected === "object" &&
        this.selected.text != ""
      );
    },
    isSelectedString() {
      return (
        this.selected &&
        typeof this.selected === "string" &&
        this.selected != ""
      );
    },
    isNotMultipleNorSelected() {
      return !this.multiple && this.selected && this.selected.text == undefined;
    },
    showMainText() {
      return (
        !this.isSearchable &&
        (this.isSelectedObject ||
          this.isSelectedString ||
          this.isNotMultipleNorSelected ||
          this.multiple)
      );
    },
    isMultipleNotSelected() {
      return this.multiple ? this.selected && this.selected.length == 0 : false;
    },
  },
  methods: {
    clickItem: function (item) {
      //Now the control is touched - So Validation Codes can execute
      this.touched = true;

      if (!this.multiple) {
        this.selectSingle(item);
      } else {
        this.selectMultiple(item);
      }

      this.validate();
    },
    selectSingle: function (item) {
      // console.log(this.optionsList, item);
      this.showDrodpownList = false;
      const itemValue = `${item.value}`;
      // console.log('sel sing', this.showDrodpownList);

      // this.$emit('selectedChange', item);

      // SelectedItemC select system

      // const optionItem = this.optionsList.map((e) => {
      //   if (e.value === item.value) {
      //     if (!e.selected) {
      //       e.selected = true;
      //     } else {
      //       e.selected = false;
      //     }
      //   } else {
      //     e.selected = false;
      //   }
      // });

      // TODO: Check if any Dropdown Control has issue with this

      // if (this.selectedIds.has(itemValue)) {
      //   this.selectedIds = addRemoveSet(
      //     false,
      //     this.selectedIds,
      //     itemValue
      //   );
      // } else {
      // }
      this.selectedIds = new Set([itemValue]);

      this.emitSelected();
    },
    selectMultiple: function (item) {
      // const optionItem = this.optionsList.find(
      //   (e) => e.value === item.value
      // );
      const itemValue = `${item.value}`;

      if (!this.selectedIds.has(itemValue)) {
        // Handle Maximum Selection before Selecting Item
        if (this.selectedItemsC.length >= this.maxSelection) {
          this.handleMaxSelection(item);
          return;
        } else {
          // this.selectedIds.add(item.value);
          this.selectedIds = addRemoveSet(true, this.selectedIds, itemValue);
        }
      } else {
        this.selectedIds = addRemoveSet(false, this.selectedIds, itemValue);
      }
      // console.log(this.optionsList, this.selectedItemsC);

      // if (this.inputType === 'string_array') {
      //   this.$emit('selectedChange', this.selectedItems.map(e => e.text));
      // } else {
      //   this.$emit('selectedChange', this.selectedItems);
      // }

      this.emitSelected();
    },
    handleMaxSelection: function (item) {
      NotificationService.showNotification({
        text: `Maximum ${this.maxSelection} Items can be selected`,
        timeout: 5000,
        type: "error",
      });
    },
    emitSelected: function () {
      // console.log(this.selectedItemsC);

      if (this.multiple) {
        if (
          this.inputType === "string_array" &&
          this.selectedItemsC.length > 0
        ) {
          this.$emit(
            "selectedChange",
            this.selectedItemsC.map((e) => e.text)
          );
        } else {
          this.$emit("selectedChange", this.selectedItemsC);
        }
      } else {
        // let item = {};
        if (this.selectedIdsArray && this.selectedIdsArray.length === 1) {
          // item = this.selectedItemsC[0];
          this.$emit("selectedChange", this.selectedItemsC[0]);
          this.setSearchString(this.selectedItemsC[0].text);
          return;
        } else if (this.selectedItemsC && this.selectedItemsC.length > 1) {
          throw Error(
            "More than one Item is selected in a single select drodpown"
          );
        } else {
          this.$emit("selectedChange", {});
        }

        // if (this.inputType === "string_array") {
        //   this.$emit("selectedChange", item);
        // } else {
        //   this.$emit("selectedChange", item);
        // }
      }
    },
    onCheckboxChange: function (e, cl) {
      // console.log(cl);
      e.stopPropagation();
    },
    // toggleDropdown() {
    //   // console.log(this.optionsList, this.selectedItemsC, this.$refs);

    //   this.scrollIntoView();

    //   if (this.showDrodpownList) {
    //     this.hideDropdown();
    //   } else {
    //     this.showDropdown();
    //   }
    // },
    scrollIntoView: function () {
      // console.log('scrollIntoView');
      if (this.multiple === false && this.selectedItemsC.length === 1) {
        const itemRef = `optionItem${this.selectedItemsC[0].value}`;
        setTimeout(() => {
          this.$refs[itemRef] &&
            this.$refs[itemRef][0] &&
            this.$refs[itemRef][0].scrollIntoView();
        }, 100);
      }
    },
    // clickOutsideEventListener: function(e) {
    //   if (!this.$el.contains(e.target)) {
    //     this.hideDropdown();
    //   }
    // },
    // showDropdown: function() {
    //   // console.log('before show dro', this.showDrodpownList);
    //   if (!this.showDrodpownList) {
    //     this.showDrodpownList = true;
    //     // window.addEventListener('click', this.clickOutsideEventListener);
    //   }
    //   // console.log('show dro', this.showDrodpownList);

    // },
    // hideDropdown: function() {
    //   if (this.showDrodpownList) {
    //     this.showDrodpownList = false;
    //     // window.removeEventListener('click', this.clickOutsideEventListener);
    //   }
    //   // console.log('hide dro', this.showDrodpownList);
    // },
    resetSelectedIds() {
      this.selectedIds = new Set();
      this.showDrodpownList = false;
    },
    onDeselect: function () {
      // Deselect Set Version
      this.resetSelectedIds();

      // this.optionsList.map((e) => {
      //   e.selected = false;
      // });
      this.$emit("selectedChange", {});
    },
    onAllnone: function () {
      // console.log(this.selectedItemsC.length, this.optionsList.length)
      if (this.selectedItemsC.length == this.optionsList.length) {
        this.resetSelectedIds();
        // this.optionsList.map((e) => {
        //   e.selected = false;
        // });
      } else {
        this.selectedIds = new Set(this.optionsList.map((e) => `${e.value}`));
        // this.optionsList.map((e) => {
        //   e.selected = true;
        // });
      }
      this.emitSelected();
    },
    onShowDrodpownListChange: function (event) {
      // console.log('show dro input', event);
      this.showDrodpownList = event;
    },

    defaultValidationResult: function () {
      return {
        valid: true,
        errorMessages: [],
      };
    },
    resetValidationResult: function () {
      this.validationResult = this.defaultValidationResult();
    },
    validate: function () {
      this.resetValidationResult();

      if (this.required) {
        if (!(this.selectedItemsC && this.selectedItemsC.length > 0)) {
          this.validationResult = {
            valid: false,
            errorMessages: [
              ...this.validationResult.errorMessages,
              `${this.placeholder} Must be selected`,
            ],
          };
        } else {
          this.validationResult = {
            valid: true,
            errorMessages: [`Valid`],
          };
        }
      }
      // console.warn(`validate 929 ${this.selectedItemsC?.map(e => e.value)} ${this.validationResult?.valid}`);
      // console.log(
      //   `dropdown.vue:915 this.selectedItemsC ${this.selectedItemsC?.map(
      //     (e) => e.value
      //   )}`
      // );

      this.emitValidation();
    },
    emitValidation: function () {
      this.$emit("validated", this.validationResult);
    },

    errorMessages: function () {
      return (
        this.validationResult.errorMessages &&
        this.validationResult.errorMessages.join("\n")
      );
    },
    resetPassiveSearchData(key = "") {
      this.psBuffer = key;
      this.psTime = getTimeNumber();
    },
    lazyResetPassiveSearchData(key) {
      if (this.psTimeout) {
        this.cancelResetPassiveSearchData();
      }
      this.psTimeout = setTimeout(() => {
        this.resetPassiveSearchData(key);
      }, 1000);
    },
    cancelResetPassiveSearchData() {
      console.log({ cancelResetPassiveSearchData: 1 });
      if (this.psTimeout) {
        clearTimeout(this.psTimeout);
      }
    },
    onDropdownKeyup: function (event) {
      console.log("Log: event", event);
      const alphabet = getAlphabet();
      const { key } = event;
      if (alphabet.includes(key)) {
        const now = getTimeNumber();
        console.log({ "now - this.psTime": now - this.psTime });
        // console.log({"this.psTime": this.psTime});
        // console.log({"now": now});
        this.psBuffer += key;

        const searchIndexes = this.optionsList
          .map((e, i) => {
            if (new RegExp(`^${this.psBuffer}.*`, "i").test(e.text)) {
              return i;
            }
            return false;
          })
          .filter((e) => e);

        this.lazyResetPassiveSearchData("");

        if (searchIndexes?.length > 0) {
          this.focusIndex(cycleArrayNext(searchIndexes, this.focusedIndex));
        } else {
          const optionIndexes = this.optionsList
            .map((e, i) => {
              if (new RegExp(`^${key}.*`, "i").test(e.text)) {
                return i;
              }
              return false;
            })
            .filter((e) => e);

          this.focusIndex(cycleArrayNext(optionIndexes, this.focusedIndex));
        }
      } else if (key === "Enter" || key === " ") {
        const highlightedItem = this.optionsList[this.focusedIndex];
        this.clickItem(highlightedItem);
      } else if (key === "Escape") {
        this.showDrodpownList = false;
        event.preventDefault();
      } else if (key === "Tab") {
        this.showDrodpownList = false;
        event.preventDefault();
      } else {
        const nextDir = ["ArrowDown", "ArrowRight"].includes(key)
          ? 1
          : ["ArrowUp", "ArrowLeft"].includes(key)
          ? -1
          : 0;
        if (nextDir != 0) {
          this.focusIndex(this.focusedIndex + nextDir);
          event.preventDefault();
        }
      }
    },
    focusIndex: function (index) {
      this.focusedIndex =
        index >= 0 && index < this.optionsList.length
          ? index
          : this.focusedIndex;
      let itemRef;
      if (
        this.optionsList[this.focusedIndex] &&
        this.optionsList[this.focusedIndex].value
      ) {
        itemRef = `optionItem${this.optionsList[this.focusedIndex].value}`;
      }
      // console.log(this.$refs[itemRef]);
      // console.log("Log: index", index, itemRef);
      this.$refs[itemRef]?.[0]?.focus();
      this.$refs[itemRef]?.[0]?.scrollIntoView();
    },
    onRootKeyDown: function (event) {
      const { key } = event;
      if (key === "Enter" || key === " ") {
        this.showDrodpownList = true;
        event.stopPropagation();
      } else if (
        ["ArrowDown", "ArrowRight", "ArrowUp", "ArrowLeft"].includes(key)
      ) {
        const highlightedItem = this.optionsList[this.focusedIndex];
        this.clickItem(highlightedItem);
        const nextDir = ["ArrowDown", "ArrowRight"].includes(key)
          ? 1
          : ["ArrowUp", "ArrowLeft"].includes(key)
          ? -1
          : 0;
        if (nextDir != 0) {
          this.focusIndex(this.focusedIndex + nextDir);
          event.preventDefault();
        }
      }
    },

    setSearchString(value = "") {
      this.searchString = value;
    },
    onSearchStringChange(event) {
      this.setSearchString(event.target.value);
      this.searchSubject.next(event.target.value);
    },
    onSearchFocus(event) {
      this.searchTypeFlag = true;
    },
    onFocus(event) {
      if (this.isSearchable) {
        let ele = document.getElementById("searchableInput");
        if (ele) {
          ele.focus();
        }
      }
    },
    onSearchBlur(event) {
      this.$emit("searchedBlur", event.target.value);
      setTimeout(() => {
        this.setSearchString(this.selected?.text);
        setTimeout(() => {
          this.searchTypeFlag = false;
        }, 20);
      }, 200);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.dropdown {
  position: relative;
  text-align: left;
  --border-color: var(--sprt-5);

  /* max-width: 178px; */
  &:focus-visible {
    outline: none;
    border: 1px solid var(--sprt-2) !important;
  }

  &:focus,
  &:active {
    outline: none;
  }

  &.searchable {
    /* border-bottom: 1px solid var(--border-color); */
    --border-color: var(--sprt-85);

    /* .dropdown--main__search-input,
    .dropdown--main__icon {
      border-bottom: 1px solid var(--sprt-85);
    } */

    .dropdown--main {
      padding: 0px;
    }

    &.box {
      .dropdown--main__search-input {
        margin-top: 4px;
      }
    }
  }

  .dropdown--main {
    padding: 5px;

    cursor: pointer;

    display: flex;
    flex-direction: row;

    &.borderbottom {
      border-bottom: 1px solid var(--border-color);
    }

    .dropdown--main__label {
      position: absolute;
      font-size: 11px;
      top: -2px;
      color: var(--sprt-2);

      overflow: hidden;
      word-wrap: break-word;
      text-overflow: ellipsis;
      white-space: nowrap;

      transition: 200ms ease-out;

      &.expanded {
        font-size: inherit;
        top: 7px;
      }
    }

    .dropdown--main__text {
      flex: 6;
      overflow: hidden;
      word-wrap: break-word;
      text-overflow: ellipsis;
      white-space: nowrap;

      color: black;

      display: flex;
      align-items: center;

      .dropdown--main__status {
        width: 10px;
        min-width: 10px;
        height: 10px;

        border-radius: 45px;
        margin: 0px 8px 0px 0px;
      }
    }

    .dropdown--main__search-input {
      flex: 4;
      /* overflow: hidden;
      word-wrap: break-word;
      text-overflow: ellipsis;
      white-space: nowrap; */

      input {
        border-bottom: 1px solid transparent;
        width: 100%;
        outline: none;

        &:active,
        &:focus {
          /* border-bottom: 1px solid var(--sprt-85); */
        }
      }
    }

    .dropdown--main__icon {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      padding-right: 5px;

      // position: absolute;
      // margin-top: 5px;
      // right: 5px;
    }
  }

  &.shrink-margin {
    .dropdown--main {
      padding-left: 0px;

      .dropdown--main__text {
        color: var(--text-5) !important;

        .placeholder {
          color: var(--text-5) !important;
        }
      }
    }

    .dropdown--main__icon {
      width: 14px;
      max-width: 14px;
      padding-right: 0px;
      margin-right: -8px;
    }
  }

  &.m1 {
    margin: 4px 5px;
  }

  &.m2 {
    margin: 6px 0px;
  }

  &.box {
    border: 1px solid var(--sprt-5);
    border-radius: 5px;
    padding: 4px 0px;
    // margin-right: 5px;

    //Height of all the Boxed Dropdown is same
    height: 42px;
    min-height: 42px;

    .dropdown--main {
      padding: 5px 5px 0px 5px;
    }

    &.hide-label {
      .dropdown--main__text {
        margin-top: 7px;
      }
    }

    .dropdown--main__icon {
      // Height of Box Dropdown ICON is same - because otherwise it changes based on the flex sibling dropdown-main-text's existence
      height: 22px;
    }

    .dropdown--main {
      margin-left: 5px;
    }

    .dropdown--list {
      margin-top: 5px;
    }
  }

  &.box:not(.hide-label) {
    .dropdown--main__text {
      margin-bottom: auto;
      margin-top: 6px;
    }
  }

  &.hide-label {
    height: 30px;
    padding: 0px;

    & > .row.wrap {
      height: 100%;

      & > .flex {
        height: 100%;

        & > .menu {
          height: 100%;

          .dropdown--main {
            height: 100%;
            padding: 0px 5px !important;
            align-items: center;

            .dropdown--main__text {
              /* height: 100%;
              align-items: center; */
              margin-top: auto;
              margin-bottom: auto;
            }

            .dropdown--main__label {
              top: 0px;
              position: relative;
              margin-top: auto;
              margin-bottom: auto;
            }

            .dropdown--main__icon {
              /* max-width: 25px; */
              margin-top: auto;
              margin-bottom: auto;
            }
          }
        }
      }
    }
  }

  &.bb1 {
    .dropdown--main {
      border-bottom: 1px solid var(--sprt-5);
    }
  }

  &.disabled {
    opacity: 0.5;
    background-color: var(--sprt-9);
  }

  &.v2 {
    height: 25px;
    border: 1px solid var(--sprt-7);

    .dropdown--main {
      margin-top: -2px;
    }
  }

  .menu__activator {
    &.menu__activator--active {
      .dropdown--main {
        .dropdown--main__text {
          span {
            color: var(--bc-darkest);
          }
        }
      }
    }

    .dropdown--main {
      .placeholder {
        color: var(--text-5) !important;
      }
    }
  }
}

.dropdown--list {
  background: white;
  width: 100%;

  z-index: 99;

  overflow-y: auto;
  box-shadow: 0px 5px 6px 2px #f1f1f1;

  .dropdown--item {
    cursor: pointer;
    padding: 6px 20px;

    // border-bottom: 1px solid #ececec;

    display: flex;

    .dropdown-item--checkbox {
      margin-top: 5px;
      margin-right: 5px;
    }

    .dropdown--item--text {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      position: relative;

      &.status {
        display: flex;
        max-width: fit-content !important;

        .dropdown--item--status {
          width: 10px;
          min-width: 10px;
          height: 10px;

          border-radius: 45px;
          margin: 0px 8px 0px 0px;
        }
      }
    }

    &.separator {
      cursor: auto;
      font-weight: 500;
      background: inear-gradient(
        180deg,
        hsla(0, 0%, 92.5%, 0),
        hsla(0, 100%, 50%, 0) 46%,
        #3e3e3e,
        hsl(0, 0%, 0%, 0) 55%,
        hsla(0, 0%, 100%, 0)
      );
    }

    &:focus:not(.separator),
    &:active:not(.separator) {
      outline: none;
      background: #c8c8c842;
      // border: 1px solid gray;
      // background: red;
    }

    &:hover:not(.separator),
    &.selected:not(.separator) {
      background: #c8c8c880;
    }

    // &.selected {
    //   background: #c8c8c8c5;
    // }
  }

  .no-item {
    padding: 5px;
  }

  .checkmark {
    margin-top: 0;
  }
}

.validation-status {
  margin-right: -25px;
  height: 100%;

  position: absolute;
  top: 0px;
  right: 0px;

  &.status-inside {
    margin-right: 30px;
    // margin-top: 11px;
  }
}

.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-out;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
